import Vue from 'vue';

// Please maintain alphabetical order of plugins for sanity sake

import * as bsv from 'bootstrap-vue';

export function registerBootstrapVue (): void {
	Vue.use(bsv.AlertPlugin);
	Vue.use(bsv.BadgePlugin);
	Vue.use(bsv.ButtonPlugin);
	Vue.use(bsv.ButtonGroupPlugin);
	Vue.use(bsv.DropdownPlugin);
	Vue.use(bsv.FormCheckboxPlugin);
	Vue.use(bsv.FormGroupPlugin);
	Vue.use(bsv.FormInputPlugin);
	Vue.use(bsv.FormPlugin);
	Vue.use(bsv.FormRadioPlugin);
	Vue.use(bsv.FormSelectPlugin);
	Vue.use(bsv.FormTextareaPlugin);
	Vue.use(bsv.LayoutPlugin);
	Vue.use(bsv.ListGroupPlugin);
	Vue.use(bsv.ModalPlugin);
	Vue.use(bsv.NavbarPlugin);
	Vue.use(bsv.PopoverPlugin);
	Vue.use(bsv.SpinnerPlugin);
}
